import { FaArrowUp, FaArrowDown, FaEquals } from 'react-icons/fa'

const EstoqueIndicator = ({ estoque, minimo }) => {
  let Icon = FaEquals
  let color = '#f59e0b' // laranja

  if (estoque > minimo) {
    Icon = FaArrowUp
    color = '#16a34a' // verde
  } else if (estoque < minimo) {
    Icon = FaArrowDown
    color = '#dc2626' // vermelho
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 6,
        width: '100%',
        color,
      }}
    >
      <Icon size={10} />
      <span>{estoque}</span>
    </div>
  )
}

export default EstoqueIndicator
